import React, { useEffect, useState } from "react";
import { Container, Table, Spinner, Alert } from "react-bootstrap";
import { getEnquiries } from "../../../api"; // update path if needed
import "./enquiries.css";

const Enquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      setLoading(true);
      const res = await getEnquiries();
      console.log("Enquiries API:", res.data);

      // Check if res.data is an array
      if (Array.isArray(res.data)) {
        setEnquiries(res.data);
      } else {
        setError("Failed to load enquiries");
      }
    } catch (err) {
      setError("Something went wrong while fetching enquiries");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="enquiries-page">
      <Container>
        <h2 className="page-title">Travel Enquiries</h2>
        <p className="page-subtitle">
          All enquiries submitted from Travel Enquiry form
        </p>

        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        )}

        {!loading && error && <Alert variant="danger">{error}</Alert>}

        {!loading && !error && enquiries.length === 0 && (
          <Alert variant="info">No enquiries found</Alert>
        )}

        {!loading && enquiries.length > 0 && (
          <div className="table-responsive">
            <Table bordered hover className="enquiries-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Destination</th>
                  <th>Message</th>
                  <th>Submitted At</th>
                </tr>
              </thead>
              <tbody>
                {enquiries.map((enquiry, index) => (
                  <tr key={enquiry.id || index}>
                    <td>{index + 1}</td>
                    <td>{enquiry.name}</td>
                    <td>{enquiry.email}</td>
                    <td>{enquiry.phone}</td>
                    <td>{enquiry.destination}</td>
                    <td className="message-cell">{enquiry.message}</td>
                    <td>{enquiry.created_at}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Container>
    </section>
  );
};

export default Enquiries;
